module.exports = __webpack_public_path__ + "static/6-1f86a510947c2d0ae6255b50a3db3586.jpg";